import { QueryUserContext, UbikModuleInfo } from "@vp/ubik-fragment-types";

export const ubikModule: UbikModuleInfo = {
  dependencies: async() => [],
  queryContext: async (context: QueryUserContext) => [context.locale, context.tenant],
  warmup: async () => {},
};
